import React from 'react'
import PropTypes from 'prop-types'
import css from '../patientCard.css'

const DisabledField = ({ contactInfoLabel }) => (
  <div className={css.contactAddButtonContainer}>
    <button disabled className={css.contactAddButton}>
      Add {contactInfoLabel}
    </button>
    <div className={css.textBox} >
      <span>To gain access to this feature, please contact Rooster Grin and upgrade to Tier 2 Appointment Reminders.</span>
    </div>
  </div>
)

DisabledField.PropTypes = {
  contactInfoLabel: PropTypes.string.isRequired,
}

export default DisabledField



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactField/DisabledField.js